import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-icon-arrow-right',
  templateUrl: './icon-arrow-right.component.html',
  styleUrls: ['./icon-arrow-right.component.scss']
})
export class IconArrowRightComponent implements OnInit {
  @Input() color: string = '#262628';
  @Input() size: number = 18;

  constructor() { }

  ngOnInit() {
  }

}
